import {
  AiOutlineGithub,
  AiFillLinkedin,
  AiOutlineTwitter,
  AiFillFacebook,
  AiOutlineInstagram,
} from 'react-icons/ai';

// import logo from '../../assets/R.png';
// import { Link } from 'react-router-dom';

export const socialIcons = [
  <AiOutlineGithub />,
  <AiFillLinkedin />,
  <AiOutlineTwitter />,
  <AiFillFacebook />,
  <AiOutlineInstagram />,
];

// export const Logo = (
//   <Link to="/" className="">
//     {logo}
//   </Link>
// );

export const navItems = [
  {
    name: 'Home',
    id: '/',
  },
  {
    name: 'About',
    id: 'about',
  },
  {
    name: 'Service',
    id: 'service',
  },
  {
    name: 'Projects',
    id: 'portfolio',
  },
  {
    name: 'Contacts',
    id: 'contact',
  },
  {
    name: 'Blog',
    id: '/blog',
  },
];
